export default import.meta.ROLLDOWN_FILE_URL_dlxJqxKmjmgf0BwBxD_HNA